<template>
  <div class="service">
    <div class="service-value">
      <h2>核心价值</h2>
      <div class="value-content">
        <div v-for="(item, index) in valueList" :key="index">
          <address class="item-top clearfix" :class="{ show1: show == index }">
            <img :src="item.img" />
            <span>{{ item.title }}</span>
            <img
              @click="active(index)"
              src="../../static/images/service_mobile/jiantou.png"
            />
          </address>
          <address class="item-bottom" :class="{ show: show == index }">
            <span>{{ item.text }}</span>
          </address>
        </div>
      </div>
    </div>
    <div class="service-add">
      <h2>八大增值服务</h2>
      <div class="add-content">
        <img class="content-img" src="../../static/images/service_mobile/tu.png" />
        <address class="content-item">
          <img src="../../static/images/service_mobile/chanpin.png" />
          <span>产品策划</span>
        </address>
        <address class="content-item">
          <img src="../../static/images/service_mobile/yiduiyi.png" />
          <span>提供一对一网络营销推广培训服务</span>
        </address>
        <address class="content-item">
          <img src="../../static/images/service_mobile/IT.png" />
          <span>IT架构分析</span>
        </address>
        <address class="content-item">
          <img src="../../static/images/service_mobile/fuwuqi.png" />
          <span>专业服务器运维</span>
        </address>
        <address class="content-item">
          <img src="../../static/images/service_mobile/youhua.png" />
          <span>流程优化</span>
        </address>
        <address class="content-item">
          <img src="../../static/images/service_mobile/shangjia.png" />
          <span>微信/APP上架指导</span>
        </address>
        <address class="content-item">
          <img src="../../static/images/service_mobile/yunying.png" />
          <span>运营咨询服务</span>
        </address>
        <address class="content-item">
          <img src="../../static/images/service_mobile/disanfang.png" />
          <span>第三方服务商推荐</span>
        </address>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'serviceCenter',
  data() {
    return {
      valueList: [
        {
          id: 1,
          title: '需求调研分析',
          img: require("../../static/images/service_mobile/1.png"),
          text: '快速建立起行业&企业需求调研分析体系，合理运用技术工具帮助客户明确业务目标和技术实现需求。'
        },
        {
          id: 2,
          title: '信息化管理方案创新',
          img: require("../../static/images/service_mobile/2.png"),
          text: '沉淀行业知识经验、实践企业信息化管理，创新出更适合客户企业情况IT治理方法和优化方案。'
        },
        {
          id: 3,
          title: '系统生命力架构设计',
          img: require("../../static/images/service_mobile/3.png"),
          text: '简化复杂的业务逻辑和需求，搭建系统实现的核心框架，确保系统具有高维护性/扩展性/集成性。'
        },
        {
          id: 4,
          title: '敏捷模式开发流程',
          img: require("../../static/images/service_mobile/4.png"),
          text: '遵循需求不断完善、测试驱动开发等原则，采用迭代开发流程，为企业带来超预期产品。'
        },
        {
          id: 5,
          title: '项目质量管理体制',
          img: require("../../static/images/service_mobile/5.png"),
          text: '遵循需求不断完善、测试驱动开发等原则，采用迭代开发流程，为企业带来超预期产品。'
        },
        {
          id: 6,
          title: '组件化软件开发技术平台',
          img: require("../../static/images/service_mobile/6.png"),
          text: '在自主研发的软件开发平台上高效率低成本地扩展新功能、配置新流程，灵活快速地促进IT与业务融合。'
        },
        {
          id: 7,
          title: '项目沟通-交付体系',
          img: require("../../static/images/service_mobile/7.png"),
          text: '建立起内外部双方密切互动的项目沟通平台，确保需求传递和实现一致性，为客户规避软件外包风险。'
        },
        {
          id: 8,
          title: '信息化实施成效档案',
          img: require("../../static/images/service_mobile/8.png"),
          text: '关注企业客户信息化实施后的目标绩效情况，持续帮助客户改进软件系统使用效果，发展企业竞争优势。'
        },
      ],
      show: -1,
    }
  },
  methods: {
    active: function (index) {
      if (this.show == index) {
        this.show = -1;
      } else {
        this.show = index;
      }
    }
  },
}
</script>

<style lang="stylus" scoped>
.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.service {
  letter-spacing: 1px;
  margin: 0 auto;
  text-align: center;
  font-family: PingFang SC;
}

h2 {
  font-size: 19px;
  font-weight: 800;
}

.service-value {
  margin-top: 10%;

  .value-content {
    margin-top: 5%;

    .item-top {
      width: 92%;
      padding: 5% 5%;
      background: #FFFFFF;
      border: 1px solid #E1E6F0;
      margin: 0 auto;

      img {
        float: left;
      }

      span {
        display: inline-block;
        float: left;
        font-weight: 12px;
        line-height: 20px;
        margin-left: 4%;
      }

      img:last-child {
        float: right;
        transform: rotate(180deg);
        margin-top: 2%;
        margin-right: 2%;
      }
    }

    .show1 {
      span {
        font-weight: 800;
      }

      img:last-child {
        transform: rotate(0);
      }
    }

    .item-bottom {
      width: 92%;
      margin: 0 auto;
      padding: 8% 5%;
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      line-height: 26px;
      text-align: left;
      display: none;
    }

    .show {
      display: block;
    }
  }
}

.service-add {
  margin-top: 10%;
  margin-bottom: 17%;

  .add-content {
    margin-top: 5%;

    .content-img{
      margin-bottom: 3%;
    }

    .content-item {
      width: 92%;
      margin: 0 auto;
      margin-top: 7%;
      text-align: left;

      span {
        display: inline-block;
        margin-left: 1%;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/ServiceCenter.vue